import * as types from 'src/store/types';
export default {
  browserLanguage () {
    let language = navigator.language || navigator.userLanguage
    language = language.split('-')[0]
    return language === 'ru' ? 'ru' : 'en'
  }
};
